<template>
  <div>
    <FlotoPageHeader
      use-divider
      :title="`${$tc('baseline')} ${$tc('history')}`"
    />
    <FlotoCrudContainer
      as-table
      prepend-new-item
      selectable
      :max-allowed-selection="2"
      :scrollable="false"
      :fetch-fn="getBaselineHistory"
      :columns="tableColumns"
      :show-no-data="false"
    >
      <template v-slot:bulk-actions="slotData">
        <BulkActions v-bind="slotData" />
      </template>
      <template v-slot:createdById="{ item }">
        <td class="text-ellipsis">
          <FlotoUserDrawer :user-id="item.createdById" disabled />
        </td>
      </template>
      <template v-slot:createdTime="{ item }">
        <td class="text-ellipsis">
          <span v-if="item.createdTime">
            {{ item.createdTime | datetime }}
          </span>
          <span v-else>---</span>
        </td>
      </template>
      <template v-slot:latest="{ item }">
        <td class="text-ellipsis">
          {{ item.latest === true ? $tc('yes') : $tc('no') }}
        </td>
      </template>
      <template v-slot:changeName="{ item }">
        <td class="text-ellipsis">
          <span v-if="item.changeName">
            <ResourceListTitle
              :name="item.changeName"
              open-in-new-tab
              :link="
                $modules.getModuleRoute('ticket', 'view', {
                  params: { id: item.changeId, ticketType: $constants.CHANGE },
                })
              "
            />
          </span>
          <span v-else>---</span>
        </td>
      </template>
      <template v-slot:changeStatusId="{ item }">
        <td class="text-ellipsis">
          <FlotoStatusPicker
            disabled
            :value="item.changeStatusId"
            placeholder="---"
            :module-name="$constants.CHANGE"
          />
        </td>
      </template>
      <template v-slot:incidentName="{ item }">
        <td class="text-ellipsis">
          <span v-if="item.incidentName">
            <ResourceListTitle
              :name="item.incidentName"
              open-in-new-tab
              :link="
                $modules.getModuleRoute('ticket', 'view', {
                  params: {
                    id: item.incidentId,
                    ticketType: $constants.REQUEST,
                  },
                })
              "
            />
          </span>
          <span v-else>---</span>
        </td>
      </template>
      <template v-slot:incidentStatusId="{ item }">
        <td class="text-ellipsis">
          <FlotoStatusPicker
            disabled
            :value="item.incidentStatusId"
            placeholder="---"
            :module-name="$constants.REQUEST"
          />
        </td>
      </template>
      <template v-slot:actions="{ item }">
        <td>
          <div class="flex flex-1 items-censter">
            <BaselineHistoryDrawer :attributes="item.rules" :item="item" />
          </div>
        </td>
      </template>
    </FlotoCrudContainer>
  </div>
</template>
<script>
import {
  buildFlatQualificationStructure,
  buildRelationalQualificationStructure,
} from '@data/qualification'
import ResourceListTitle from '@components/resource/resource-list-title'
import BulkActions from './bulk-actions'
import { getBaselineHistoryApi } from '../../../asset-api'
import BaselineHistoryDrawer from './baseline-history-drawer'
export default {
  name: 'BaselineHistoryTab',
  components: { BaselineHistoryDrawer, BulkActions, ResourceListTitle },
  props: {
    resourceId: { type: Number, required: true },
  },
  data() {
    this.tableColumns = [
      {
        name: `${this.$tc('id')}`,
        key: 'name',
        minWidth: '100px',
        width: '100px',
      },
      { name: `${this.$tc('created_by')}`, key: 'createdById' },
      {
        name: `${this.$tc('created_on')}`,
        key: 'createdTime',
      },
      {
        name: `${this.$tc('reason')}`,
        key: 'reason',
      },
      {
        name: `${this.$tc('change')} ${this.$tc('id')}`,
        key: 'changeName',
      },
      {
        name: `${this.$tc('change')} ${this.$tc('status')}`,
        key: 'changeStatusId',
        width: '150px',
        minWidth: '150px',
      },
      {
        name: `${this.$tc('request')} ${this.$tc('id')} `,
        key: 'incidentName',
      },
      {
        name: `${this.$tc('request')} ${this.$tc('status')} `,
        key: 'incidentStatusId',
      },
      {
        name: `${this.$tc('latest')} `,
        key: 'latest',
      },
      {
        name: `${this.$tc('action', 2)}`,
        key: 'actions',
        width: '120px',
      },
    ]
    return {}
  },
  methods: {
    getBaselineHistory(limit, offset) {
      return getBaselineHistoryApi(
        {
          qualDetails: buildFlatQualificationStructure([
            buildRelationalQualificationStructure(
              'assetId',
              'equal',
              this.resourceId,
              'long',
              'db'
            ),
          ]),
        },
        limit,
        offset
      )
    },
  },
}
</script>
